import { render } from "./AutoSync.vue?vue&type=template&id=656589c8"
import script from "./AutoSync.vue?vue&type=script&lang=js"
export * from "./AutoSync.vue?vue&type=script&lang=js"

import exportComponent from "/Users/lolo/projects/mygpsworkouts-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__